import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { UserType } from '../../../../common/dist/common';

export interface IAuthState {
  isLogin: boolean;
  type: UserType;
  isAccepted: boolean;
  name: string;
  email: string;
}

@Module({ dynamic: true, store, name: 'Auth' })
export default class Auth extends VuexModule implements IAuthState {
  public isLogin = false;
  public type = UserType.User;
  public isAccepted = false;
  public target = 0;
  public name = '';
  public email = '';
  public nonce = '';

  @Mutation
  public setLogin({ isLogin, type, isAccepted, name, email, nonce }: { isLogin: boolean, type: UserType, isAccepted?: boolean, name?: string, email?: string, nonce: string }) {
    this.isLogin = isLogin;
    this.type = type;
    this.isAccepted = isAccepted || false;
    this.name = name || '';
    this.email = email || '';
    this.nonce = nonce || '';
  }

  @Action({})
  public async login({ type, isAccepted }: { type: UserType, isAccepted: boolean }) {
    this.setLogin({ isLogin: true, type, isAccepted, nonce: '' });
  }

  @Action({})
  public logout() {
    this.setLogin({ isLogin: false, type: UserType.User, nonce: '' });
  }
}

export const AuthModule = getModule(Auth);
